// For scrolling lists on the wall tablet: is there more below the fold?
// Used to fade the bottom edge, so a list that's cut off says "scroll"
// instead of looking like a broken line of text.

import { useEffect, useRef, useState } from 'react';

export function useMoreBelow<T extends HTMLElement>(deps: unknown[] = []) {
  const ref = useRef<T>(null);
  const [more, setMore] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => setMore(el.scrollHeight - el.scrollTop - el.clientHeight > 4);
    check();
    el.addEventListener('scroll', check, { passive: true });
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(check) : undefined;
    ro?.observe(el);
    return () => {
      el.removeEventListener('scroll', check);
      ro?.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return { ref, more };
}
